import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "aot_token";
export const EMAIL_KEY = "aot_email";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const login = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  setToken(data.token);
  localStorage.setItem(EMAIL_KEY, data.email);
  return data;
};

export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const fetchAgents = () => api.get("/agents").then((r) => r.data);
export const fetchAgent = (id) => api.get(`/agents/${id}`).then((r) => r.data);
export const createAgent = (payload) => api.post("/agents", payload).then((r) => r.data);
export const updateAgent = (id, payload) => api.patch(`/agents/${id}`, payload).then((r) => r.data);
export const deleteAgent = (id) => api.delete(`/agents/${id}`).then((r) => r.data);
export const fetchLeads = (id) => api.get(`/agents/${id}/leads`).then((r) => r.data);
export const runAgent = (id) => api.post(`/agents/${id}/run`).then((r) => r.data);
export const updateLead = (id, payload) => api.patch(`/leads/${id}`, payload).then((r) => r.data);
export const draftEmail = (id, language) =>
  api.post(`/leads/${id}/draft-email`, language ? { language } : {}).then((r) => r.data);
export const exportUrl = (id) => `${API_BASE}/agents/${id}/leads/export?token=${encodeURIComponent(getToken() || "")}`;
